<section>
  <div class="form-register">
    <form [formGroup]="formRemissionDetail">
      <div class="row p-1">
        <div class="col-lg-3 col-md-6 col-sm-6 col-12">
          <app-custom-input-text [value]="codeNameArticle" [disabled]="true" [labelText]="'Artículo'">
          </app-custom-input-text>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-6 col-12">
          <app-custom-input-text formControlName="storeCodeName" [disabled]="true" [labelText]="'Bodega'">
          </app-custom-input-text>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="stock" [labelText]="'Existencias'"
            [disabled]="true"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="availableStock"
            [labelText]="'Disponible'"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="quantity" [labelText]="'Cantidad'"
            (onChangeNumber)="changeQuantity($event)"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-6 col-12">
          <app-custom-input-text formControlName="unitInvoiced" [disabled]="true" [labelText]="'Unidad Fra.'">
          </app-custom-input-text>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="baseUnitValue" [labelText]="'Vr.Base'"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="discount" [labelText]="'% Dcto.'"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="unitValue" [labelText]="'Vr.Cliente'"></app-custom-input-decimal>
        </div>
        <div class="col-lg-3 col-md-2 col-sm-6 col-12">
          <app-custom-input-text formControlName="detailText" [disabled]="true" [labelText]="'Detalle'"
            [maxLength]="60">
          </app-custom-input-text>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12 col-12 d-flex justify-content-start">
          <div class="d-flex align-items-end gap-1">
            <app-custom-button [label]="'Guardar'" [severity]="'primary'" (onClick)="send()"></app-custom-button>
            <app-custom-button [label]="'Cancelar'" [severity]="'danger'" (onClick)="clearForm()"></app-custom-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>